module.exports = __webpack_public_path__ + "assets/img/kefu2.86317839.png";